import { createContext, useContext, type ComponentType } from 'react'

export type Steps = {
  [k in string]: ComponentType
}

type StepContextProps = {
  goToStep: (step: keyof Steps) => void
  ActiveComponent: ComponentType
  activeStep: string
}

export const StepperContext = createContext<StepContextProps>({} as StepContextProps)

export const useStepper = () => useContext(StepperContext)
